module.exports = require('./dist/structured-content');
